// extracted by mini-css-extract-plugin
export default {"badges":"item-list-page_badges__z4Epo"};